<template>
  <div>
    <el-drawer
      title="Historico de procesos internos"
      :visible.sync="drawer"
      size="50%"
    >
      <div>
        <h2 style="text-align: center">Procesos internos</h2>
        <rabbey-table-3
          :paginationApi="{
            currentPage: pageExecuted,
            pageSize: limitExecuted,
            total: totalItemsExecuted
          }"
          :pageSizes="pageSizes"
          :loading="loadingExecuted"
          :paginateFromApi="true"
          :data="itemsExecuted"
          :columns="columnsProcessesDetails"
          @update-current-page="handleCurrentPageExecuted"
          @update-page-size="handlePageSizeExecuted"
        />
      </div>
    </el-drawer>

    <rabbey-table-3
      :paginationApi="{
        currentPage: page,
        pageSize: limit,
        total: totalItems
      }"
      :pageSizes="pageSizes"
      :loading="loading"
      :actions="actions"
      :paginateFromApi="true"
      :data="items"
      :columns="columnsDetails"
      @update-current-page="handleCurrentPage"
      @update-page-size="handlePageSize"
      @rtable-push-action="onPushAction"
    />
  </div>
</template>

<script>
import { formatDate } from "@/utils";
export default {
  data() {
    return {
      page: 1,
      limit: 10,
      totalItems: 0,
      pageExecuted: 1,
      limitExecuted: 10,
      totalItemsExecuted: 0,
      pageSizes: [10, 30, 50, 100, 600],
      dialogVisible: false,
      drawer: false,
      loading: false,
      ProcessesId: "",
      loadingExecuted: false,
      items: [],
      itemsExecuted: [],
      CustomersFilter: "",
      columnsDetails: [
        {
          prop: "Id",
          label: "NO. Pro",
          width: 100,
          sortable: true
        },
        {
          prop: "Name",
          label: "Nombre",
          width: 600,
          sortable: true
        },
        {
          prop: "Description",
          label: "Descripcion",
          width: 740,
          sortable: true
        }
      ],
      columnsProcessesDetails: [
        {
          prop: "InternalProcessesId",
          label: "Identificador",
          width: 250,
          sortable: true
        },
        {
          prop: "StartDate",
          label: "Fecha de inicio",
          width: 250,
          sortable: true
        },
        {
          prop: "EndDate",
          label: "Fecha de fin",
          width: 250,
          sortable: true
        },
        {
          prop: "ExecutionTime",
          label: "Minutos en ejecucion",
          width: 200,
          sortable: true
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        }
      ]
    };
  },
  created() {
    this.fecthCustomers();
  },
  methods: {
    handleCurrentPage(page) {
      this.page = page;

      this.fecthCustomers();
    },
    handlePageSize(limit) {
      this.limit = limit;

      this.fecthCustomers();
    },
    handleCurrentPageExecuted(page) {
      this.pageExecuted = page;

      this.getInternalProcessesExecuted();
    },
    handlePageSizeExecuted(limit) {
      this.limitExecuted = limit;

      this.getInternalProcessesExecuted();
    },
    async onPushAction(action) {
      this.actionRowData = action;

      let ProcessesId;
      if (action.row.Name) {
        ProcessesId = action.row.Name;
      }

      switch (action.command) {
        case "view":
          this.viewProcesses(ProcessesId);
          break;
      }
    },
    viewProcesses(processId) {
      this.ProcessesId = processId;
      this.getInternalProcessesExecuted();

      this.drawer = true;
    },
    fecthCustomers() {
      this.items = [];
      this.loading = true;
      this.$http
        .get(`/api/InternalProcesses`, {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit
          }
        })
        .then((resp) => {
          const { Items, ItemCount, CurrentPage } = resp.data;

          this.items = Items;
          this.totalItems = ItemCount;
          this.page = CurrentPage;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getInternalProcessesExecuted() {
      this.itemsExecuted = [];
      this.loadingExecuted = true;
      this.$http
        .get(`/api/InternalProcesses/GetInternalProcess`, {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.pageExecuted,
            Limit: this.limitExecuted,
            InternalProcessesId: this.ProcessesId
          }
        })
        .then((resp) => {
          const { Items, ItemCount, CurrentPage } = resp.data;

          let itemsFormater = [];
          Items.forEach((value) => {
            const { InternalProcessesId, StartDate, EndDate, ExecutionTime } =
              value;

            itemsFormater.push({
              InternalProcessesId,
              StartDate: formatDate(new Date(StartDate)),
              EndDate: formatDate(new Date(EndDate)),
              ExecutionTime
            });
          });

          this.itemsExecuted = itemsFormater;
          this.totalItemsExecuted = ItemCount;
          this.pageExecuted = CurrentPage;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loadingExecuted = false;
        });
    }
  }
};
</script>
